module.exports = __webpack_public_path__ + "img/inventory-add.ae6afe6a.png";